export default __webpack_public_path__ + "static/media/flower-1 2.db13a3af.png";